import { Box, Grid, List, ListItem, RadioGroup, Radio, Tab } from "@mui/material";
import { TabList } from "@mui/lab";
import { styled } from "@mui/material/styles";

import { PROFILE_SETTINGS_LAYOUT_MAX_WIDTH } from "./constants";

export const StyledContainer = styled(Grid)({
  display: "flex",
  flex: 1,
  minHeight: 0,
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  margin: 0,
  alignItems: "stretch",
});

export const StyledContentGrid = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  minHeight: 0,
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",

  "& > *": {
    width: "100%",
    maxWidth: PROFILE_SETTINGS_LAYOUT_MAX_WIDTH,
  },

  "& > *:last-child": {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "auto !important",
  },

  "& form[data-testid='Profile-form']": {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
  },
});

export const StyledProfileFormFields = styled(Box)({
  flex: "1 1 0",
  minHeight: 0,
  width: "100%",
  maxWidth: PROFILE_SETTINGS_LAYOUT_MAX_WIDTH,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

export const StyledList = styled(List)(({ theme }) => ({
  width: "auto",
  maxWidth: "100%",
  minWidth: 420,
  padding: 0,
  marginBottom: theme.spacing(1),
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  // Base styles
  cursor: "grab",
  userSelect: "none",
  padding: 0,
  minHeight: "32px",
  transition: "all 0.2s ease",

  // States
  "&:hover, &.dragging": {
    backgroundColor: "var(--hover-color, rgba(3, 169, 244, 0.08))",
  },

  // MUI Components
  "& .MuiListItemText-root": {
    margin: `0 ${theme.spacing(4)} 0 ${theme.spacing(1)}`,
  },

  "& .MuiIconButton-root": {
    padding: theme.spacing(0.5),
  },

  "& .MuiFormControlLabel-root": {
    margin: 0,
    marginInlineStart: theme.spacing(1),
  },
}));

export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  flexWrap: "wrap",
  "& .MuiFormControlLabel-root": {
    marginRight: theme.spacing(2),
    minWidth: "50px",
    marginBottom: 0,
  },
}));

export const StyledRadio = styled(Radio)(({ theme }) => ({
  "& .MuiTouchRipple-root": {
    transitionDuration: `${theme.transitions.duration.shortest}ms`,
  },
  "& .MuiSvgIcon-root": {
    transition: `transform ${theme.transitions.duration.shortest}ms`,
  },
}));

export const StyledProfileSettingsLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "stretch",
  flex: "1 1 0",
  minHeight: 0,
  overflow: "hidden",
  gap: theme.spacing(3),
  width: "100%",
  maxWidth: PROFILE_SETTINGS_LAYOUT_MAX_WIDTH,
  marginLeft: "auto",
  marginRight: "auto",

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

export const StyledProfileTabList = styled(TabList)(({ theme }) => ({
  flexShrink: 0,
  minWidth: 240,
  maxWidth: 320,
  alignSelf: "stretch",
  maxHeight: "100%",
  overflowY: "auto",
  borderRight: `1px solid ${theme.palette.divider}`,

  "& .MuiTabs-flexContainer": {
    alignItems: "stretch",
  },

  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    borderRight: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

export const StyledProfileTab = styled(Tab)(({ theme }) => ({
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "left",
  textTransform: "none",
  fontWeight: 500,
  fontSize: theme.typography.body2.fontSize,
  lineHeight: 1.35,
  minHeight: 40,
  padding: theme.spacing(1, 2),
  whiteSpace: "normal",

  "&.Mui-selected": {
    fontWeight: 600,
  },
}));

export const StyledProfileTabsContentArea = styled(Box)({
  flex: "1 1 0",
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

export const StyledProfileTabPanelScroll = styled(Box)(({ theme }) => ({
  flex: "1 1 0",
  minHeight: 0,
  height: "100%",
  overflowY: "auto",
  overflowX: "hidden",
  WebkitOverflowScrolling: "touch",
  padding: theme.spacing(0, 1, 2, 3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2, 0, 0),
  },
}));

export const StyledProfileTabPanelContent = styled(Box)({
  maxWidth: "var(--max-content-width, 800px)",
  width: "auto",
  alignSelf: "center",
});
